import Box from '@material-ui/core/Box';
import React from 'react';

export function TabPanel(props) {
  const { children, value, index, padding = 3, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={padding}>{children}</Box>}
    </div>
  );
}
